module.exports = __webpack_public_path__ + "static/media/heart.23b5c2c0.png";